import { useRouter } from 'next/router';
import { CheckoutParamEnum } from '../types';

export const useCheckoutParams = () => {
  const router = useRouter();

  const adults = router.query?.[CheckoutParamEnum.adults] as string | undefined;
  const bid = router.query?.[CheckoutParamEnum.bookingId] as string | undefined;
  const children = router.query?.[CheckoutParamEnum.children] as string | undefined;
  const endDate = router.query?.[CheckoutParamEnum.endDate] as string | undefined;
  const infants = router.query?.[CheckoutParamEnum.infants] as string | undefined;
  const marketing = router.query?.[CheckoutParamEnum.marketing] as string | undefined;
  const message = router.query?.[CheckoutParamEnum.message] as string | undefined;
  const paymentType = router.query?.[CheckoutParamEnum.paymentType] as string | undefined;
  const pets = router.query?.[CheckoutParamEnum.pets] as string | undefined;
  const propertyId = router.query?.[CheckoutParamEnum.propertyId] as string | undefined;
  const startDate = router.query?.[CheckoutParamEnum.startDate] as string | undefined;
  const step = router.query?.[CheckoutParamEnum.step] as string | undefined;
  const owner_offer_code = router.query?.[CheckoutParamEnum.owner_offer_code] as string | undefined;
  const owner_offer_id = router.query?.[CheckoutParamEnum.owner_offer_id] as string | undefined;
  const allura_offer_code = router.query?.[CheckoutParamEnum.allura_offer_code] as string | undefined;
  const allura_offer_id = router.query?.[CheckoutParamEnum.allura_offer_id] as string | undefined;
  const owner_gift_certificate_code = router.query?.[CheckoutParamEnum.owner_gift_certificate_code] as string | undefined;
  const owner_gift_certificate_id = router.query?.[CheckoutParamEnum.owner_gift_certificate_id] as string | undefined;
  const allura_gift_certificate_code = router.query?.[CheckoutParamEnum.allura_gift_certificate_code] as string | undefined;
  const allura_gift_certificate_id = router.query?.[CheckoutParamEnum.allura_gift_certificate_id] as string | undefined;

  // const promo_not_used_confirm = router.query?.[CheckoutParamEnum.promo_not_used_confirm] as string | undefined;
  return {
    adults,
    bid,
    children,
    endDate,
    infants,
    marketing,
    message,
    paymentType,
    pets,
    propertyId,
    startDate,
    step,
    owner_gift_certificate_code,
    owner_gift_certificate_id,
    owner_offer_code,
    owner_offer_id,
    allura_gift_certificate_code,
    allura_gift_certificate_id,
    allura_offer_code,
    allura_offer_id,
  };
};
